module.exports = __webpack_public_path__ + "img/turkey.7d033137.png";